export default __webpack_public_path__ + "static/media/1.d4c4828f.png";